
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import "../../../style/buttons.scss";
import {
  BIRTHDAY_RESERVATION,
  CALENDAR_SALE,
  EVENT_SALE,
  EXERCISE_SCHEDULE,
  GIFT_CARD_ACTIVE,
  LIMITED_TICKET_COLOR,
  LIMITED_TICKET_GROUP,
  LIMITED_TICKET_SHAPE,
  MAIN_APP,
  NEWS_PAGE,
  PASSES_SALE,
  THREE_STEP,
} from "../../../app/routes";
import { ComponentList } from "../../../app/models/ComponentList";
import { useTranslation } from "react-i18next";

interface IProps {
  item: ComponentList;
  onClick?: () => void;
}

const DesktopNavBarButton: React.FC<IProps> = ({ item, onClick = () => {} }: IProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [link, setLink] = useState("");

  const linkMap: { [key: string]: string } = {
    EventSaleActive: EVENT_SALE,
    NewsActive: NEWS_PAGE,
    GiftCardActive: GIFT_CARD_ACTIVE,
    StepByStepSaleActive: THREE_STEP,
    StepByStepSaleActiveV2: CALENDAR_SALE,
    BirthDaysActive: BIRTHDAY_RESERVATION,
    PassSale: PASSES_SALE,
    Calendar: EXERCISE_SCHEDULE,
    Shapes: LIMITED_TICKET_SHAPE,
    Groups: LIMITED_TICKET_GROUP,
    Colors: LIMITED_TICKET_COLOR,
  };

  useEffect(() => {
    setLink(linkMap[item.id] || MAIN_APP);
    //eslint-disable-next-line
  }, [item]);

  const isActiveRoute = (): boolean => {
    return location.pathname === link;
  };

  return (
    <React.Fragment>
      {item.active && (
        <Link
          onClick={onClick}
          className={
            isActiveRoute()
              ? "button button-fill-background-main medium padding-small"
              : "button button-text-gray medium padding-small"
          }
          to={link}
        >
          {t(item.name)}
        </Link>
      )}
    </React.Fragment>
  );
};

export default DesktopNavBarButton;
